<template>
	<transition 
			appear
			:appear-active-class="$_tmlnMsgBdyCrd_styleComponentAnimation()">
		<template v-if="$_tmlnMsgBdyCrd_stateComponentIsInitialized">
			<v-row dense>
				<v-col>
					<v-card	class="customVCard card_"
							:color="$_tmlnMsgBdyCrd_styleMessageCardColor"
							:dark="$_tmlnMsgBdyCrd_styleMessageCardDark"
							:elevation="$_tmlnMsgBdyCrd_styleMessageCardElevation"
							:flat="$_tmlnMsgBdyCrd_styleMessageCardFlat"
							:hover="$_tmlnMsgBdyCrd_styleMessageCardHover"
							:light="$_tmlnMsgBdyCrd_styleMessageCardLight"
							:outlined="$_tmlnMsgBdyCrd_styleMessageCardOutlined"
							:raised="$_tmlnMsgBdyCrd_styleMessageCardRaised"
							:tile="$_tmlnMsgBdyCrd_styleMessageCardTile">
						<!-- text / html -->
						<v-card-text>
							<span v-html="message['text']" />
						</v-card-text>
						<!-- tag -->
						<template v-if="!isEmpty(message['tag'])">
							<v-card-text class="cardText_ pb-3">
								<v-row dense>
									<template v-for="tag in message['tag']">
										<v-col :key="tag" cols="auto">
											<v-chip label>
												<v-avatar left>
													<v-icon small>label</v-icon>
												</v-avatar>
												<span v-text="tag" />
											</v-chip>
										</v-col>
									</template>
								</v-row>
							</v-card-text>
						</template>
						<!-- attachment -->
						<template v-if="!isFalse(message['attachment_file_url'])">
							<v-card-text class="cardText_ pb-3">
								<v-alert
										class="customVAlert"
										dense
										text
										:value="true">
									<v-row align="center" dense>
										<v-col class="mr-2" cols="auto">
											<v-icon >attachment</v-icon>
										</v-col>
										<v-col>
											<span	class="caption"
													v-text="message['attachment_file_url']" />
										</v-col>
										<v-col cols="auto">
											<v-btn icon @click="openLink({ url: message['attachment_file_url'] })">
												<v-icon>save_alt</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-alert>
							</v-card-text>
						</template>
						<!-- quoted message -->
						<template v-if="!isEmpty(message['quoted_message'])">
							<v-card-text class="cardText_ pb-3">
								<v-alert
										class="customVAlert"
										dense
										text
										:value="true">
									<v-row align="center" dense>
										<v-col class="mr-2" cols="auto">
											<v-icon >keyboard_arrow_right</v-icon>
										</v-col>
										<v-col>
											<span	class="caption"
													v-text="message['quoted_message'].text" />
										</v-col>
									</v-row>
								</v-alert>
							</v-card-text>
						</template>
					</v-card>
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'TimelineMessageBodyCard',
		props: {
			message: Object
		},
		data() {
			return {
				componentName_: 'timelineMessageBodyCard'
			}
		},
		computed: {
			// current user
			$_tmlnMsgBdyCrd_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_tmlnMsgBdyCrd_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_tmlnMsgBdyCrd_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_tmlnMsgBdyCrd_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_tmlnMsgBdyCrd_langOpenLinkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tmlnMsgBdyCrd_inits(), 'openLinkButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// style
			$_tmlnMsgBdyCrd_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_tmlnMsgBdyCrd_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_tmlnMsgBdyCrd_inits(), 'component')
				}
			},
			$_tmlnMsgBdyCrd_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_tmlnMsgBdyCrd_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_tmlnMsgBdyCrd_styleMessageCard() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tmlnMsgBdyCrd_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tmlnMsgBdyCrd_inits(), 'messageCard')
			},
			$_tmlnMsgBdyCrd_styleMessageCardColor() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.color)
			},
			$_tmlnMsgBdyCrd_styleMessageCardDark() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.dark)
			},
			$_tmlnMsgBdyCrd_styleMessageCardElevation() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.elevation)
			},
			$_tmlnMsgBdyCrd_styleMessageCardFlat() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.flat)
			},
			$_tmlnMsgBdyCrd_styleMessageCardHover() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.hover)
			},
			$_tmlnMsgBdyCrd_styleMessageCardLight() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.light)
			},
			$_tmlnMsgBdyCrd_styleMessageCardOutlined() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.outlined)
			},
			$_tmlnMsgBdyCrd_styleMessageCardRaised() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.raised)
			},
			$_tmlnMsgBdyCrd_styleMessageCardTile() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgBdyCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.tile)
			},
			$_tmlnMsgBdyCrd_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_tmlnMsgBdyCrd_inits(), 'chip')
			},
			$_tmlnMsgBdyCrd_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_tmlnMsgBdyCrd_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_tmlnMsgBdyCrd_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_tmlnMsgBdyCrd_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_tmlnMsgBdyCrd_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_tmlnMsgBdyCrd_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_tmlnMsgBdyCrd_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgBdyCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			}
		},
		methods: {
			$_tmlnMsgBdyCrd_checkMessageIsSentMessage(messageVals) {
				const self_ = this;
				const uid_ = self_.$_tmlnMsgBdyCrd_currentUserUid;
				return messageVals.sender == uid_;
			}
		}
	}
</script>

<style scoped>
	.card_ {
		padding: 8px;
	}
	.cardImage_ {
		margin: 0 4px;
	}
	.cardText_ {
		padding: 0 4px;
	}
</style>